import React from "react";

const JobLoader = () => {
    return (
      <div className="flex flex-col items-center justify-center h-[60vh]">
        <div className="w-16 h-16 relative">
          <div className="w-16 h-16 rounded-full border-4 border-accent-light"></div>
          <div className="w-16 h-16 rounded-full border-4 border-primary-headings border-t-transparent animate-spin absolute top-0"></div>
        </div>
        <p className="mt-4 text-accent-dark">Creating your job...</p>
      </div>
    );
};

export default JobLoader;